// This key is used by the Zendesk component to render the Zendesk Web Widget.
// When manually adding this widget to a webpage, the ZENDESK_KEY is included as
// part of the script tag and is visible in the DOM. So this key shouldn't be treated as "secret" or "secure".
// Adding it here as a constant since this is the only component using the Zendesk component currently.
// Could be moved to a shared location if that changes in the future.
// ref: https://developer.zendesk.com/documentation/classic-web-widget-sdks/web-widget/quickstart-tutorials/web-widget-javascript-apis/#adding-the-web-widget-classic-on-your-web-page

const ZENDESK_PRODUCTION_KEY = "88f2eb5c-80e1-47bd-95ae-6005b892222a";

export const ZENDESK_KEY = ZENDESK_PRODUCTION_KEY;

// We're suppressing all features of the web widget except for the Help Center
// ref: https://developer.zendesk.com/api-reference/widget/settings/#suppress
export const PARTNER_DASHBOARD_ZENDESK_SETTINGS = {
  chat: {
    suppress: true,
  },
  contactForm: {
    suppress: true,
  },
  talk: {
    suppress: true,
  },
  answerBot: {
    suppress: true,
  },
};

export const PARTICIPANT_DASHBOARD_ZENDESK_SETTINGS = {
  chat: {
    suppress: true,
  },
  helpCenter: {
    suppress: true,
  },
  talk: {
    suppress: true,
  },
  answerBot: {
    suppress: true,
  },
  offset: {
    // there is already a 20px margin applied to the right of the iframe, so this is adding 16px for a total of 36px
    horizontal: "16px",
    // there is already a 10px margin applied to the bottom of the iframe, so this is adding 14px for a total of 24px
    vertical: "14px",
    mobile: {
      // there is already a 20px margin applied to the right of the iframe, which this is keeping
      horizontal: "0px",
      // there is already a 10px margin applied to the bottom of the iframe, so this is adding 74px for a total of 84px
      // (specifically, we need to move the help button above the bottom nav on mobile)
      vertical: "84px",
    },
  },
};

export const LANDING_PAGE_ZENDESK_SETTINGS = {
  chat: {
    suppress: true,
  },
  helpCenter: {
    suppress: true,
  },
  talk: {
    suppress: true,
  },
  answerBot: {
    suppress: true,
  },
};
